import React from 'react';

import {DataFrame} from 'data-frames/DataFrameTypes';
import convertDataFrameToRunQueryOutput from 'data-frames/util/legacy/convertDataFrameToRunQueryOutput';
import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {AnalyticsVisualization} from 'insights/analytics-visualizations/__generated/AnalyticsVisualization';
import {VisualizationType} from 'insights/analytics-visualizations/AnalyticsVisualizationTypes';
import useResolvedRunQueryOutput from 'insights/analytics-visualizations/chip-items/useResolvedRunQueryOutput';
import InlineBanner, {InlineBannerType} from 'ui-library/banners/InlineBanner';

import DeprecatedLineChart from './deprecated-react-charts/DeprecatedLineChart';
import convertToContinuous2DChartProps from './prop-converters/legacy-prop-converters/convertToContinuous2DChartProps';

type LineChartParameters = ExtractByTypename<
  AnalyticsVisualization['parameters'],
  'AnalyticsVisualizationLineChartParametersNode'
>;

export default function LineChartViewer({
  dataFrame,
  isLegacyInsights,
  parameters,
}: {
  dataFrame: DataFrame;
  isLegacyInsights: boolean;
  parameters: LineChartParameters;
}): JSX.Element {
  const runQueryOutput = convertDataFrameToRunQueryOutput(dataFrame);
  const {resolvedRunQueryOutput} = useResolvedRunQueryOutput(runQueryOutput, !isLegacyInsights);
  const conversionOutput = convertToContinuous2DChartProps(
    dataFrame,
    resolvedRunQueryOutput,
    parameters,
    VisualizationType.LINE_CHART
  );
  return conversionOutput.valid ? (
    <DeprecatedLineChart {...conversionOutput.props} />
  ) : (
    <InlineBanner bannerType={InlineBannerType.ERROR} text={conversionOutput.message} />
  );
}
